module.exports = "/build/admin/images/favicon.23b6b685.ico";